const constants = {
    DELETE_TRANSACTION: 'DELETE_TRANSACTION',
    ADD_TRANSACTION: 'ADD_TRANSACTION'
}
export default constants;